import _ from 'lodash';
import ArrayUtils from './ArrayUtils';

const GmapUtils = {

  /**
   * flow: GmapType
   */
  MapType: {
    MAP: 'm',
    SATTELITE: 'k',
    HYBRID: 'h',
    TERRAIN: 'p',
    GOOGLE_EARTH: 'e'
  },

  //
  // Note: zoom
  // * 1: World
  // * 5: Landmass/continent
  // * 10: City
  // * 15: Streets
  // * 20: Buildings
  //

  getTypeOnGmapAddressComponents: (type: GmapAddressComponentType, components: GmapAddressComponents): GmapAddressComponent => {
    let res: GmapAddressComponent = null;

    _.each(components, (component: GmapAddressComponent) => {
      const index = _.indexOf(component.types, type);

      if (index != -1) {
        res = component;
        return false; // quit loop
      }
    });

    if (_.isNil(res)) {
      // return empty GmapAddressComponent to avoid errors
      return {
        long_name: '',
        short_name: '',
        types: []
      };
    }

    return res;
  },

  /**
   * @see https://stackoverflow.com/questions/2660201/what-parameters-should-i-use-in-a-google-maps-url-to-go-to-a-lat-lon
   * @type {[type]}
   */
  getGoogleMapsUrl: (position: GeoPt, zoom: GmapZoom = 10, mapType: GmapType = GmapUtils.MapType.MAP): string  => {
    return `http://maps.google.com/maps?z=${zoom}&t={mapType}&q=loc:${position.latitude}+${position.longitude}`;
  },

  getGoogleMapsDirectionUrl: (from: GeoPt, to: GeoPt, zoom: GmapZoom = 10, mapType: GmapType = GmapUtils.MapType.MAP): string  => {
    const fromFormat = `${from.latitude},${from.longitude}`;
    const toFormat = `${to.latitude},${to.longitude}`;
    return `https://www.google.com/maps/dir/${fromFormat}/${toFormat}`;
  }

}


export default GmapUtils;
